var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 20.6317H16",
    stroke: "#5545A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63206 17.2633C8.43734 17.2633 8.17858 17.1455 8.05287 17.026L0.894606 10.2891C0.569472 9.97457 0.531877 9.46498 0.861711 9.09843C1.15689 8.77065 1.73225 8.76242 2.05271 9.06553L7.78974 14.4733L7.78974 0.842048C7.78974 0.376813 8.16686 4.0378e-07 8.63179 4.28695e-07C9.09703 4.53625e-07 9.47384 0.377121 9.47384 0.842048L9.47384 14.4733L15.2109 9.06553C15.5313 8.76243 16.0926 8.78387 16.4016 9.09843C16.7279 9.43032 16.6988 9.97958 16.3687 10.2891L9.21071 17.026C9.01657 17.2239 8.82973 17.26 8.63206 17.2633Z",
    fill: "#5545A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientDownloadIcon);
export default __webpack_public_path__ + "static/media/patient-download-icon.ce3eaeb0702407085d90fd30d34c7bf6.svg";
export { ForwardRef as ReactComponent };